// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import VsrMessage from '@deere/cps-it.warranty-model-factory/lib/claim-vsr-message';

const obj = {
    LABOR: 'labor',
    OTHERCREDITS: 'credit',
    PARTS: 'part'
};

function getErrorClassName(vsrMessage) {

    const errorField = vsrMessage.errorField.key || `${obj[vsrMessage.errorField.itemType]}-item-${parseInt(vsrMessage.errorField.itemNumber, 10)}`;

    return errorField ? errorField.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase() : '';

}

function handleClick(vsrMessage) {

    const errorClassName = getErrorClassName(vsrMessage);

    if (errorClassName) {

        const element = document.querySelector(`.${errorClassName} input, .${errorClassName} select, .${errorClassName} textarea`);

        element.focus();

        if (element.type === 'checkbox') {

            element.parentElement.scrollIntoView({block: 'center', inline: 'center'});

        }

    }

}

const VsrMessages = props =>
    props.vsrMessages.length ?
        <div className={props.className}>
            <h3>{props.title}</h3>
            <ul>
                {
                    props.vsrMessages.map((vsrMessage, index) =>
                        <li key={index}>
                            {
                                (vsrMessage.errorField.key || vsrMessage.errorField.itemNumber) && props.isEditable ?
                                    <a onClick={handleClick.bind(props, vsrMessage)}>{vsrMessage.message}</a> :
                                    <span>{vsrMessage.message}</span>
                            }

                        </li>
                    )
                }
            </ul>
        </div> :
        null;

VsrMessages.displayName = 'VsrMessages';
VsrMessages.propTypes = {
    className: PropTypes.string.isRequired,
    isEditable: PropTypes.bool,
    title: PropTypes.string,
    vsrMessages: PropTypes.arrayOf(PropTypes.instanceOf(VsrMessage)).isRequired
};

export default VsrMessages;



// WEBPACK FOOTER //
// ./src/claim/shared/components/vsr-messages/index.js